const protectedUrls = ['dashboard', 'account'];

export { protectedUrls };
